import type { MessageTemplate } from "../../messageTemplates/types";
import { isFluxmedDefaultMessageTemplate } from "../../messageTemplates/utils/messageTemplateUiUtils";
import { tryParseQuestionnaireIdFromButtonUrl } from "../../messageTemplates/utils/questionnaireTemplateButtonUrl";

/**
 * Deriva o id do questionário vinculado a um template WhatsApp
 * a partir da URL do botão (`buttonValue`).
 */
export function resolveQuestionnaireIdFromTemplate(
  template: MessageTemplate | undefined,
): string | null {
  return tryParseQuestionnaireIdFromButtonUrl(template?.buttonValue);
}

export function resolveQuestionnaireFromTemplate(
  template: MessageTemplate | undefined,
  questionnaireNameById: Map<string, string>,
): { questionnaireId?: string; questionnaireName?: string } {
  const questionnaireId = resolveQuestionnaireIdFromTemplate(template) ?? undefined;
  if (!questionnaireId) {
    return {};
  }

  return {
    questionnaireId,
    questionnaireName: questionnaireNameById.get(questionnaireId),
  };
}

/**
 * Modelos elegíveis para automação: da organização e fora da aba Padrão.
 */
export function filterAutomationSelectableTemplates(
  templates: MessageTemplate[],
  organizationId: string,
): MessageTemplate[] {
  return templates.filter(
    (template) =>
      !isFluxmedDefaultMessageTemplate(template.name, organizationId),
  );
}
